import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { useTheme } from './useTheme';

const C = { turquesa:'#5dc1b9', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)' };
const font = "'DM Sans', sans-serif";

export default function ProfileReminders() {
  const navigate = useNavigate();
  const { profile } = useAuth();
  const t = useTheme();
  if (!profile) return null;

  const reminders = [];
  if (!profile.project_story) reminders.push({ emoji:'📖', title:'Cuéntale al mundo tu historia', desc:'Los proyectos con historia reciben más atención. Cuéntanos cómo empezaste.', btn:'Escribir mi historia' });
  if (!profile.avatar_url) reminders.push({ emoji:'📸', title:'Sube tu foto de perfil', desc:'La comunidad quiere conocerte. Sube una foto para que te identifiquen.', btn:'Subir foto' });
  if (!profile.instagram && !profile.tiktok && !profile.facebook) reminders.push({ emoji:'📱', title:'Agrega tus redes sociales', desc:'Para que la comunidad te siga y conozca tu trabajo.', btn:'Agregar redes' });

  if (reminders.length === 0) return null;

  return (
    <div style={{ marginBottom:'2rem', display:'flex', flexDirection:'column', gap:10 }}>
      {reminders.map((r, i) => (
        <div key={i} style={{ background:`linear-gradient(135deg, rgba(93,193,185,0.06), rgba(253,190,2,0.04))`, border:`0.5px solid rgba(93,193,185,0.2)`, borderRadius:16, padding:'14px 18px', display:'flex', alignItems:'center', gap:12, flexWrap:'wrap' }}>
          <span style={{ fontSize:24 }}>{r.emoji}</span>
          <div style={{ flex:1, minWidth:160 }}>
            <p style={{ fontSize:14, fontWeight:500, margin:'0 0 2px' }}>{r.title}</p>
            <p style={{ fontSize:12, color:t.textSecondary, margin:0 }}>{r.desc}</p>
          </div>
          <button onClick={()=>navigate('/perfil')} style={{ background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'7px 18px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:font, whiteSpace:'nowrap' }}>{r.btn}</button>
        </div>
      ))}
    </div>
  );
}
